<template>
  <div class="info-area">
    <span>您好，{{username}}</span>
    <span class="logout" @click='logouthandle'>退出</span>
    <!-- <el-dropdown trigger="click" @command="dropdownComm" class="info-area__dropdown">
      <span class="el-dropdown-link">
        您好，{{username}}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <span>退出</span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="logout">{{$t('sidebarDropDown.logout')}}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown> -->
  </div>
</template>

<script>
export default {
  name: 'demo',
  computed: {
    username() {
      return this.$store.state.user.realName
    }
  },
  methods: {
    dropdownComm(command) {
      switch (command) {
        case 'logout':
          this.logouthandle()
          break
        case 'lock':
          this.lockhandle()
          break
        case 'profile':
          this.jumpToProfile()
          break
      }
    },
    async logouthandle() {
      await this.$store.dispatch('logout')
      this.clearCookie();
      window.location.reload()
    },
    lockhandle() {
      this.$store.dispatch('setLockState', 'lock')
      this.$router.push({
        path: '/lock'
      })
      this.$message.success(this.$t('lock.locked'))
    },
    clearCookie(){
        var date=new Date();
        date.setTime(date.getTime()-10000);
        var keys=document.cookie.match(/[^ =;]+(?=\=)/g);
        if (keys) {
            for (var i =  keys.length; i--;){
              document.cookie= keys[i] + "=0;expires="+date.toGMTString();
            }
              // document.cookie=keys[i]+"=0; expire="+date.toGMTString()+"; path=/";
        }
    },
    jumpToProfile() {
      // this.$router.push({
      //   path: '/profile/index'
      // })
    }
  }
}
</script>

<style lang="stylus" scoped>
.el-dropdown-link
  font-weight 600
  color #6FADDC
.inline-block-box
  display inline-block
  vertical-align middle

.info-area
  font-size 18px
  color rgba(255,255,255,0.9)
  display flex
  align-items center
  span 
    margin-top 7px
    cursor pointer
  .logout
    margin 7px 80px 0
</style>
